var React = require('react');

function Fail (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.2,4.2C7.2,4.2,7.1,4.2,7.2,4.2c-2.1,0-3.7,1.8-3.6,3.8c0,0,0,0,0,0c0,0,0,0,0,0C2,8.1,0.8,9.4,0.8,11c0,1.7,1.3,3.1,3,3.1\n\t\tc0.1,0,7.4,0,7.4,0c1.4,0,2.6-0.7,3.3-1.8","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.2","y1":"10","x2":"15.2","y2":"2","key":1}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"15.2","y1":"10","x2":"7.2","y2":"2","key":2})]));
}

Fail.displayName = "Fail";

Fail.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Fail;

Fail.default = Fail;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/fail.svg
// module id = ../icon/src/icons/fail.svg
// module chunks = 0